module.exports = window["__sharedEmotionCache"];